class AlgoliaIconCaretDown extends HTMLElement {
  constructor() {
    super();

    this.connectedCallback = this.connectedCallback.bind(this);
    this.getStyle = this.getStyle.bind(this);
    this.render = this.render.bind(this);
  }

  /**
   * Initializes settings based on custom attributes when the element is connected to the DOM.
   * @returns {void}
   */
  connectedCallback() {
    this.settings = {
      defaultIconCaretDownUrl: this.getAttribute('default-icon-caret-down-url'),
      iconCaretDownSize: this.getAttribute('icon-caret-down-size'),
      iconCaretDownUrl: this.getAttribute('icon-caret-down-url')
    }
  }

  /**
   * Returns the CSS styles.
   * @returns {string} The CSS style block as a string.
   */
  getStyle() {

    const css = `
      .icon-caret-down {
        background-image: url(${this.settings.iconCaretDownUrl ? this.settings.iconCaretDownUrl : this.settings.defaultIconCaretDownUrl});
        background-position: center;
        background-repeat: no-repeat;
        background-size: ${this.settings.iconCaretDownSize}%;
        height: 100%;
        width: 100%;
      }
    `;

    const style = document.createElement('style');
    style.appendChild(document.createTextNode(css));
    return style;
  }

  /**
   * Renders the icon content.
   * @returns {string} The rendered icon.
   */
  render() {
    const style = this.getStyle();
    const div = document.createElement('div');
    div.classList.add('icon');
    div.classList.add('icon-caret-down');
    div.setAttribute('aria-hidden', 'true');
    div.setAttribute('focusable', 'false');
    div.textContent = ' ';
    
    return [style, div];
  }
}

customElements.define("algolia-icon-caret-down", AlgoliaIconCaretDown);